import type { TextFieldProps } from "@mui/material"
import { TextField } from "@mui/material"
import type { ReactElement } from "react"
import { forwardRef } from "react"

export interface AerosTextFieldProps extends Omit<TextFieldProps, "onChange"> {
  onChange?: (value: string) => void
}

export const AerosTextField = forwardRef<HTMLDivElement, AerosTextFieldProps>(
  ({ onChange, ...props }, ref): ReactElement => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onChange?.(e.target.value)
    }

    return <TextField {...props} ref={ref} onChange={handleChange} variant='outlined' fullWidth />
  }
)
